<div id="paymentLoadingContainer">
  <mat-spinner id="paymentLoadingSpinner" [diameter]="40"></mat-spinner>
</div>
